import React from "react";
import styled, { withTheme } from "styled-components";

const StyledButton = styled.button`
  width: 100%;
  color: ${(props) => props.theme?.black};
  background-color: ${(props) => props.theme?.white};
  max-height: 75px;
  text-align: justify;
  font-weight: 600;
  padding: 8px 32px;

  :hover {
    color: #fff !important;
    background-color: ${(props) => props.theme?.darkPurple} !important;
    border-color: ${(props) => props.theme?.darkPurple} !important;

    span {
      background-color: ${(props) => props.theme?.white};
      border-color: ${(props) => props.theme?.white};
      color: ${(props) => props.theme?.darkPurple};
    }
  }

  :focus {
    box-shadow: 0 0 0 0.2rem rgba(167, 32, 140, 0.5);
  }
`;

const StyledBadge = styled.span`
  display: grid;
  place-items: center;
  border: 5px solid ${(props) => props.theme?.darkPurple};
  background-color: ${(props) => props.theme?.darkPurple};
  border-radius: 2px;
  color: ${(props) => props.theme?.white};
  font-size: 0.65rem;
`;

const StyledButtonContentContainer = styled.div`
  height: 40px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto 20px;
  align-items: center;
`;

const BadgeButton = (props) => {
  const { id, text, ...rest } = props;

  return (
    <StyledButton
      id={id ? `${id}-btn` : "default-badge-btn-id"}
      className="btn"
      {...rest}
    >
      <StyledButtonContentContainer>
        {text}

        <StyledBadge className="fas fa-plus fa-xs" />
      </StyledButtonContentContainer>
    </StyledButton>
  );
};

export default withTheme(BadgeButton);
